import { IconName, Menu, MenuProps, Position } from "@blueprintjs/core"
import CustomPopover, {
  CustomPopoverProps,
} from "components/Atoms/CustomPopover"
import React, { createContext } from "react"
import ActionButton from "../Molecules/ActionButton"

export interface ActionItemContextProps {
  onClick?: (action: string) => void | undefined
}
export const ActionItemContext = createContext<ActionItemContextProps>({})

/**
 * Inherit all the properties from the ActionItemContextProps because all the properties required by the context
 * should be implemented in the context as well
 */
export interface ActionMenuProps
  extends Omit<MenuProps, "onClick">,
    ActionItemContextProps {
  /**
   * className for the menu
   */
  menuClassName?: string
  popoverProps?: CustomPopoverProps
  button?: Element
  position?: any
  icon?: IconName
  rightIcon?: IconName
  small?: boolean
  loading?: boolean
  disabled?: boolean
  text?: any
}

const ActionMenu = ({
  id,
  position,
  onClick,
  className,
  menuClassName,
  popoverProps,
  children,
  button,
  disabled = false,
  ...otherProps
}: ActionMenuProps) => {
  return (
    <CustomPopover
      minimal
      position={position}
      disabled={disabled}
      popoverClassName={popoverProps && popoverProps.className}
      {...popoverProps}
      content={
        <Menu className={menuClassName} id={id}>
          <ActionItemContext.Provider value={{ onClick }}>
            {children}
          </ActionItemContext.Provider>
        </Menu>
      }
    >
      {button || (
        <ActionButton
          disabled={disabled}
          className={className}
          {...otherProps}
        />
      )}
    </CustomPopover>
  )
}

ActionMenu.defaultProps = {
  position: Position.BOTTOM_LEFT,
}
export default ActionMenu
